import { FunctionComponent, ReactElement, useContext } from 'react'
import { ConfigContext } from '../../context/ConfigContext'

type InformationFrameProps = {
  icon?: ReactElement
  title?: string
  align: 'left' | 'center'
  children: ReactElement
  size?: 'small' | 'medium' | 'large'
}

const InformationFrame: FunctionComponent<InformationFrameProps> = ({
  icon,
  title,
  align,
  children,
  size = 'large',
}) => {
  const { isEcommerce } = useContext(ConfigContext)

  return (
    <>
      {isEcommerce() && (
        <section className={`information-frame align-${align} ${icon && 'flex-row'} frame-${size}`}>
          {icon && <>{icon}</>}

          <div className='information-frame-container'>
            {title && <h5 className='title-h5'>{title}</h5>}
            <div className='content'>{children}</div>
          </div>
        </section>
      )}
    </>
  )
}

export default InformationFrame
